import React from "react";

export default function MyCollectionsIcon({ ...props }: React.SVGProps<any>) {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" {...props}>
      <circle cx="16" cy="16" r="14.75" stroke="#086BE5" strokeWidth="2.5" />
      <path
        d="M19.6924 13.5385C19.6924 15.5777 18.0393 17.2308 16 17.2308C13.9608 17.2308 12.3077 15.5777 12.3077 13.5385C12.3077 11.4993 13.9608 9.84619 16 9.84619C18.0393 9.84619 19.6924 11.4993 19.6924 13.5385Z"
        fill="#086BE5"
      />
      <path
        d="M19.6924 13.5385C19.6924 15.5777 18.0393 17.2308 16 17.2308C13.9608 17.2308 12.3077 15.5777 12.3077 13.5385C12.3077 11.4993 13.9608 9.84619 16 9.84619C18.0393 9.84619 19.6924 11.4993 19.6924 13.5385Z"
        stroke="#086BE5"
      />
      <mask id="path-3-inside-1" fill="white">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.92313 26.9574C6.08607 22.0846 10.4688 18.4614 15.6978 18.4614C21.2912 18.4614 25.9163 22.6073 26.6678 27.9937C23.9345 30.4825 20.301 31.9999 16.3131 31.9999C11.7981 31.9999 7.73748 30.055 4.92313 26.9574Z"
        />
      </mask>
      <path
        d="M4.92313 26.9574L2.00508 26.261L1.63728 27.8021L2.70271 28.9747L4.92313 26.9574ZM26.6678 27.9937L28.6877 30.2119L29.8577 29.1464L29.6391 27.5791L26.6678 27.9937ZM7.84118 27.6538C8.68914 24.1008 11.8889 21.4614 15.6978 21.4614V15.4614C9.0487 15.4614 3.48299 20.0684 2.00508 26.261L7.84118 27.6538ZM15.6978 21.4614C19.7738 21.4614 23.149 24.4835 23.6966 28.4082L29.6391 27.5791C28.6836 20.731 22.8086 15.4614 15.6978 15.4614V21.4614ZM24.648 25.7755C22.4455 27.781 19.5251 28.9999 16.3131 28.9999V34.9999C21.0769 34.9999 25.4236 33.184 28.6877 30.2119L24.648 25.7755ZM16.3131 28.9999C12.6787 28.9999 9.41328 27.4382 7.14355 24.94L2.70271 28.9747C6.06168 32.6718 10.9176 34.9999 16.3131 34.9999V28.9999Z"
        fill="#086BE5"
        mask="url(#path-3-inside-1)"
      />
    </svg>
  );
}
